<script>
import ShowStatus from '@/components/ShowStatus.vue'
import { ConfiguracaoGeralEquipamento } from '@/utils/constants'

export default {
  name: 'ConfiguracaoGeralEquipamentoCard',
  components: { ShowStatus },
  props: {
    value: Object,
  },
  data() {
    return {
      configuracaoGeralEquipamento: ConfiguracaoGeralEquipamento,
    }
  },
}
</script>

<template>
  <md-card>
    <md-ripple>
      <div class="md-layout m-2">
        <div class="md-layout-item md-size-65">
          <div v-if="configuracaoGeralEquipamento[value.configName]">
            <div class="md-title" style="font-size: 1.2rem">
              {{ configuracaoGeralEquipamento[value.configName].titulo }}
            </div>
          </div>
          <div v-else class="md-title">
            <span
              v-if="!configuracaoGeralEquipamento[value.configName]"
              class="md-error"
              style="color: red"
            >
              [ERROR]
            </span>
          </div>
        </div>

        <div class="md-layout-item">
          <show-status
            :value="value.config.status"
            :config="{
              0: { label: 'Aguardando', color: '#FF9800' },
              1: { label: 'Executado', color: '#4CAF50' },
              2: { label: 'Cancelado', color: '#F44336' },
              3: { label: 'Enviado', color: '#2196F3' },
              4: { label: 'Não Enviado', color: '#949494' },
              5: { label: 'Expirado', color: '#545454' },
            }"
          />
        </div>
      </div>

      <div
        v-if="configuracaoGeralEquipamento[value.configName]"
        class="md-subhead pl-2"
      >
        {{ configuracaoGeralEquipamento[value.configName].subtitulo }}
      </div>

      <md-card-actions>
        <md-button @click="() => $emit('click', value)"> Enviar </md-button>
      </md-card-actions>
    </md-ripple>
  </md-card>
</template>

<style scoped lang="scss"></style>
